/**
 * Any appeals API calls with React Query.
 */
import { useMemo } from "react";
import { GetAppealDropdownCancelToken, GetAppealslistCancelToken } from "../../services/DashBoardServices";
import { QUERY_CACHE_PROFILES, QUERY_KEYS } from "../queryConsts";
import { useBaseReactQuery } from "./useBaseReactQuery";

const EMPTY_APPEALS_DROPDOWN = Object.freeze({
    intake: [],
    learningMethod: [],
    programme: [],
});

const EMPTY_APPEALS_LIST = Object.freeze({
    appealsList: [],
    totalRows: 0
});

export const appealsTabNames = {
    Pending: "Pending",
    Approved: "Approved",
    Declined: "Declined",

};

/**
 * Appeals Dropdown - PERSISTED
 * @param {appealsTabNames} Tab Appeals Tab name.
 * @returns {DefinedUseQueryResult} React Query result
 */
export function useAppealsDropdown(filters) {
    const query = useBaseReactQuery(
        [QUERY_KEYS.appeals.root, QUERY_KEYS.appeals.appealsDropdown, filters],
        async () => {
            const { data } = await GetAppealDropdownCancelToken(filters);

            return data;
        },
        {
            cacheProfile: QUERY_CACHE_PROFILES.LOOKUP
        }
    );

    return {
        ...query,
        data: query.data ?? EMPTY_APPEALS_DROPDOWN
    };
}

/**
 * React Query hook for Appeals lists.
 * The requestData should already be in the format expected by the API.
 *
 * @param {object} requestData Request body passed directly to the API.
 * @returns {DefinedUseQueryResult}
 */
export function useAppealsList(requestData) {
    const query = useBaseReactQuery(
        [
            QUERY_KEYS.appeals.root,
            QUERY_KEYS.appeals.appealsList,
            requestData
        ],
        async () => {
            const { data } = await GetAppealslistCancelToken(requestData);

            return {
                appealsList: data?.result ?? [],
                totalRows: data?.Pagination?.total ?? 0
            };
        },
        {
            cacheProfile: QUERY_CACHE_PROFILES.TABLE
        }
    );

    return {
        ...query,
        data: query.data ?? EMPTY_APPEALS_LIST
    };
}
